export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/turn.json")),
  ), //make sure all the values are deeply cloned
  {
    groups: ["year 4", "year 5", "year 6"],
    "editorial-only": true,
    args: {
      arguments: [
        {
          code: {
            type: "angle",
            value: null,
            title: "property",
            "hard-lock": true,
            editable: true,
          },
        },
      ],
    },
  },
);
